import { discountSummaryLabel } from '../../utils/activeGlobalDiscount';
import { shippingSummaryText } from '../../utils/shippingBehavior';

const money = (value) => `$${Number(value || 0).toFixed(2)}`;

const taxPercent = Number(process.env.REACT_APP_TAX_PERCENTAGE) * 100;

const OrderPriceSummary = ({
    subtotal = 0,
    discountAmount = 0,
    discount = null,
    shippingPrice = 0,
    shippingPending = false,
    shippingText = '',
    taxPrice = 0,
    totalLabel = 'Total:',
    total = null,
    showTotal = true,
    dense = false,
    afterDiscount = null,
    className = '',
}) => {
    const amount = Number(discountAmount) || 0;
    const rowClass = dense
        ? 'd-flex justify-content-between align-items-center mb-1'
        : 'summary-row';
    const mutedClass = dense ? 'text-muted small' : '';
    const valueClass = dense ? 'small fw-semibold' : '';

    return (
        <div className={`order-price-summary${className ? ` ${className}` : ''}`}>
            <div className={rowClass}>
                <span className={mutedClass}>Subtotal (sin IVA):</span>
                <span className={valueClass}>{money(subtotal)}</span>
            </div>
            {amount > 0 && (
                <div className={rowClass}>
                    <span className={`text-success fw-semibold${dense ? ' small' : ''}`}>{discountSummaryLabel(discount)}</span>
                    <span className={`text-success fw-semibold${dense ? ' small' : ''}`}>-{money(amount)}</span>
                </div>
            )}
            {afterDiscount}
            <div className={rowClass}>
                <span className={mutedClass}>Envío:</span>
                <span className={valueClass}>
                    {shippingText || shippingSummaryText({ shippingPrice, pending: shippingPending })}
                </span>
            </div>
            <div className={rowClass}>
                <span className={mutedClass}>IVA ({taxPercent}%):</span>
                <span className={valueClass}>{money(taxPrice)}</span>
            </div>
            {showTotal && (
                <div className={dense ? 'd-flex justify-content-between align-items-center fw-bold border-top pt-2 mt-2' : 'summary-row total'}>
                    <span>{totalLabel}</span>
                    {total}
                </div>
            )}
        </div>
    );
};

export default OrderPriceSummary;
